import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMaterialUiComponent } from './simple-icons-material-ui.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMaterialUiComponent ],
    exports:      [ SimpleIconsMaterialUiComponent ],
    bootstrap:    []
})
export class SimpleIconsMaterialUiModule {}
